import { add } from './add';
import { find } from './find';
import { remove } from './remove';
import { update } from './update';

export const resourceAPI = {
  add,
  find,
  remove,
  update,
};
